import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useState } from 'react';
import I18n from 'I18n';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'I18n... Remove this comment to see the full error message
import CjkCharacterRegExp from 'I18n/constants/regex/CJK';
import { useSelector } from 'react-redux';
import { getCurrentInboxName } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { useKeypress } from '../hooks/useKeyPress';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getEnterClickedInSearch, getSearched
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
} from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import debounce from 'react-utils/debounce';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const MIN_SEARCH_CHAR_COUNT = 3;
export const MAX_SEARCH_WORD_COUNT = 100;
export const UPDATE_FILTER_DEBOUNCE_MS = 500;
const hasExceedWordLimit = str => {
  const count = str.trim().split(/\s+/).length;
  return count > MAX_SEARCH_WORD_COUNT;
};
const isBelowMinCharCount = str => str.length < MIN_SEARCH_CHAR_COUNT;
const isWithinRange = str => CjkCharacterRegExp.test(str) || !isBelowMinCharCount(str) && !hasExceedWordLimit(str);
const MinSearchCountValidation = ({
  searchQuery
}) => {
  if (searchQuery.length && searchQuery.length < MIN_SEARCH_CHAR_COUNT && !CjkCharacterRegExp.test(searchQuery)) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: I18n.text('salesUI.UISearchInput.minimumSearchMessage', {
        count: MIN_SEARCH_CHAR_COUNT - searchQuery.length
      })
    });
  }
  return null;
};
MinSearchCountValidation.displayName = 'MinSearchCountValidation';
const debouncedSetSearchValue = debounce((currentValue, setSearchValue) => {
  setSearchValue(currentValue);
  trackEvent(getSearched({
    searchTerm: currentValue
  }));
}, UPDATE_FILTER_DEBOUNCE_MS);
export const SearchBar = ({
  clearSearchValue,
  searchValue,
  setSearchValue
}) => {
  const [typeValue, setTypeValue] = useState(searchValue);
  const inboxName = useSelector(getCurrentInboxName) || '';
  const [isFocused, setIsFocused] = useState(!!searchValue);
  useKeypress('Enter', () => {
    if (isFocused) trackEvent(getEnterClickedInSearch());
  });
  const maxSearchCountMessage = hasExceedWordLimit(typeValue) ? I18n.text('conversations-inbox-ui.thread-search-and-filtering.search-bar.errors.exceedWordLimit') : null;
  const handleSearchInputChange = currentValue => {
    setTypeValue(currentValue);
    if (isWithinRange(currentValue)) {
      debouncedSetSearchValue(currentValue, setSearchValue);
    }
    if (!currentValue) clearSearchValue();
  };
  const placeholder = I18n.text('conversations-inbox-ui.thread-search-and-filtering.search-bar.placeholder') + inboxName;
  return /*#__PURE__*/_jsx(FormControl, {
    error: !!maxSearchCountMessage,
    validationMessage: maxSearchCountMessage,
    "aria-label": "Search",
    children: /*#__PURE__*/_jsx(SearchInput, {
      value: typeValue,
      onChange: e => handleSearchInputChange(e.target.value),
      placeholder: placeholder,
      getValidationMessage: searchQuery => /*#__PURE__*/_jsx(MinSearchCountValidation, {
        searchQuery: searchQuery
      }),
      autoComplete: "off"
      // eslint-disable-next-line jsx-a11y/no-autofocus
      ,
      autoFocus: true,
      "data-test-id": "search-and-filtering-search-filter",
      onFocus: () => setIsFocused(true),
      onBlur: () => setIsFocused(false)
    })
  });
};
SearchBar.displayName = 'SearchBar';
export default SearchBar;